// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1aIIE","obliqueLineWrap":"membershipbadge_obliqueLineWrap__z4OYF","obliqueLine":"membershipbadge_obliqueLine__2xjjy"};